/* import __COLOCATED_TEMPLATE__ from './user-search-row.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import type UserSummary from 'embercom/objects/inbox/user-summary';

interface Signature {
  Element: HTMLElement;
  Args: {
    workspaceId: string;
    rowUser: UserSummary;
    openUserProfile: (workspaceId: string, userId: string, event: MouseEvent) => void;
    copyUserId: (userId: string, event: MouseEvent) => void;
    user?: UserSummary | null;
    showSelectedIcon?: boolean;
    hideId?: boolean;
  };
}

const UserSearchRow = templateOnlyComponent<Signature>();
export default UserSearchRow;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::UserSearchRow': typeof UserSearchRow;
  }
}
